import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=2d63619c"
import script from "./ProfilePicture.vue?vue&type=script&lang=ts"
export * from "./ProfilePicture.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePicture.vue?vue&type=style&index=0&id=2d63619c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports